module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/static-page/create-page/create-page.component.css
// module id = ./src/app/static-page/create-page/create-page.component.css
// module chunks = main